/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；
 *          视觉基准 docs/旅游落地页/cj商旅-01.html 第 12116~12272 行（.cjbt-compact-cta）与第 12273~12334 行内联脚本。
 * 注意事项：
 * 1. 原型脚本同 Payment：IntersectionObserver(threshold 0.16) 命中加 is-visible，降级直接可见 —— 走 useScrollReveal。
 * 2. 原型主 CTA 的 href="#cjbt-contact" 断链，决策记录见 constants.js CTA.primaryCtaHref 注释。
 * 3. 第14次补充：主 CTA 改跳站内锚点。原先主副按钮都写死 target="_blank"（那时都是外链），
 *    站内锚点若保留会新开空白页，故改用 linkTarget() 按 href 形态条件渲染。
 */
import React from 'react';
import useScrollReveal from './useScrollReveal';
import { ArrowRight } from './Icons';

/**
 * 站内锚点（#开头）不加 target/rel，外链才加新窗口 + noopener。
 * @param {string} href 链接地址
 * @returns {Object} 展开到 <a> 上的属性
 */
function linkTarget(href) {
  var isAnchor = typeof href === 'string' && href.charAt(0) === '#';
  return isAnchor ? {} : { target: '_blank', rel: 'noopener noreferrer' };
}

export default function Cta(props) {
  var CTA = props.data;
  var reveal = useScrollReveal('is-visible', 0.16);

  return (
    <section
      className="cjbt-compact-cta"
      id="cjbt-plan-your-journey"
      ref={reveal}
      /* 第2次补充：背景图随公共资源仓发布，同 Hero 走 CSS 变量注入（值已含 url(...)） */
      style={{ '--cjbt-cta-bg': CTA.backgroundCss }}
    >

      <span className="cjbt-compact-cta__shine" aria-hidden="true"></span>
      <span className="cjbt-compact-cta__circle" aria-hidden="true"></span>

      <div className="cjbt-compact-cta__container">
        <div className="cjbt-compact-cta__layout">

          {/* LEFT CONTENT */}
          <div className="cjbt-compact-cta__content">

            <div className="cjbt-compact-cta__eyebrow">{CTA.eyebrow}</div>

            <h2 className="cjbt-compact-cta__title">
              {CTA.titleLead} <em>{CTA.titleEm}</em>
            </h2>

            <p className="cjbt-compact-cta__description">{CTA.description}</p>

            <div className="cjbt-compact-cta__benefits">
              {CTA.benefits.map(function (benefit, index) {
                return (
                  <div className="cjbt-compact-cta__benefit" key={index}>
                    <span className="cjbt-compact-cta__check">✓</span>
                    {benefit}
                  </div>
                );
              })}
            </div>

            <div className="cjbt-compact-cta__actions">
              <a
                className="cjbt-compact-cta__button cjbt-compact-cta__button--primary"
                href={CTA.primaryCtaHref}
                {...linkTarget(CTA.primaryCtaHref)}
              >
                <span>{CTA.primaryCta}</span>
                <ArrowRight />
              </a>

              <a
                className="cjbt-compact-cta__button cjbt-compact-cta__button--secondary"
                href={CTA.secondaryCtaHref}
                {...linkTarget(CTA.secondaryCtaHref)}
              >
                <span>{CTA.secondaryCta}</span>
                <ArrowRight />
              </a>
            </div>

          </div>

          {/* RIGHT CARD */}
          <aside className="cjbt-compact-cta__card">

            <span className="cjbt-compact-cta__card-label">{CTA.cardLabel}</span>
            <h3 className="cjbt-compact-cta__card-title">{CTA.cardTitle}</h3>

            <div className="cjbt-compact-cta__steps">
              {CTA.steps.map(function (step) {
                return (
                  <div className="cjbt-compact-cta__step" key={step.number}>
                    {/* 需求来源：AI提示词.md 第1次提交第1次补充（DEV-120352）—— 序号位改用 iconfont 字形图标
                        （e8f1 计划 / e8f4 行程单 / e8f2 旅行），字号 18px、色 #ff7700，由 step-number 的
                        inline-flex 居中；图标为装饰性，语义由相邻标题承担，故 aria-hidden。 */}
                    <span className="cjbt-compact-cta__step-number">
                      <i className="iconfont" aria-hidden="true">{step.icon}</i>
                    </span>
                    <div>
                      <strong>{step.title}</strong>
                      <span>{step.text}</span>
                    </div>
                  </div>
                );
              })}
            </div>

          </aside>

        </div>
      </div>
    </section>
  );
}
